import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  CircularProgress,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TextField,
  Dialog,
  Modal,
  Fade,
} from "@mui/material";
import HeaderTitle from "../../../components/common/HeaderTitle/HeaderTitle";
import axios from "axios";
import { API_ENDPOINT } from "../../../services/api/resources";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SuccessPopupDashboard from "../../../components/Popups/PopupFrame/SuccessPopupDashboard";
import successPopupImg from "../../../assets/images/png/Group 2 2@2x.png";
import { db, rcRepository } from "../../../offline";

const RcPoView = ({
  selectedContract,
  onBack,
  rcInputRef,
  loading,
  setLoading,
}) => {
  const loginData = useSelector((state) => state.loginData.value);
  const auth_token = loginData?.auth_token;
  const buyer_token = loginData?.user?.token;

  const [savedItem, setSavedItem] = useState([]);
  const [quantities, setQuantities] = useState({});

  const [deliveryDate, setDeliveryDate] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [creatingPo, setCreatingPo] = useState(false);

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [openOfflinePopup, setOpenOfflinePopup] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const handleOnline = () => {
      console.log("Internet restored → syncing PO");
      rcRepository.syncOfflinePO(auth_token);
    };

    window.addEventListener("online", handleOnline);

    return () => window.removeEventListener("online", handleOnline);
  }, [auth_token]);

  const fetchRcItems = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        API_ENDPOINT.get_rc_items_,
        {
          buyer_token: buyer_token,
          rc_token: selectedContract?.rc_token || selectedContract?.token,
        },
        {
          headers: {
            Authorization: `Token ${auth_token}`,
            "Content-Type": "application/json",
          },
        },
      );

      setSavedItem(res.data || []);
    } catch (error) {
      console.error("Error fetching RC Items:", error);
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //   fetchRcItems();

  // }, []);

  useEffect(() => {
    rcRepository.syncOfflinePO(auth_token);
  }, []);

  useEffect(() => {
    if (selectedContract?.items) {
      setSavedItem(selectedContract.items);
    }
  }, [selectedContract]);

  //   useEffect(() => {
  //   const autoCreate = sessionStorage.getItem("AUTO_CREATE_PO");

  //   if (autoCreate && savedItem.length > 0) {
  //     handleCreatePO();
  //     navigate("/Buyer_dashboard/po")
  //     sessionStorage.removeItem("AUTO_CREATE_PO");
  //   }
  // }, [savedItem]);

  // useEffect(() => {
  //   if (!savedItem.length) return;

  //   const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
  //   if (!chatActionRaw) return;

  //   const { item_values, action } = JSON.parse(chatActionRaw);

  //   if (action !== "convert_rc_to_po") return;
  //   if (!item_values?.length) return;

  //   const values = item_values.map(v =>
  //     v.toString().toLowerCase().trim()
  //   );

  //   const filteredItems = savedItem.filter(item => {
  //     const code = item.item_code?.toLowerCase() || "";
  //     const name = item.item_name?.toLowerCase() || "";
  //     const part = item.part_no?.toLowerCase() || "";

  //     return values.some(v =>
  //       code.includes(v) ||
  //       name.includes(v) ||
  //       part.includes(v)
  //     );
  //   });
  //   console.log("items",filteredItems)
  //   if (filteredItems.length !== savedItem.length) {
  //     setSavedItem(filteredItems);

  //     setTimeout(() => {
  //     handleCreatePO();
  //     navigate("/Buyer_dashboard/po");
  //     sessionStorage.removeItem("CHAT_ACTION");
  //   }, 500);

  //     // stop effect from running again
  //     sessionStorage.removeItem("CHAT_ACTION");
  //   }

  //   console.log("saved item",savedItem)

  // }, [savedItem]);

  // useEffect(() => {
  //   if (!savedItem.length) return;

  //   const chatActionRaw = sessionStorage.getItem("CHAT_ACTION");
  //   if (!chatActionRaw) return;

  //   const { action } = JSON.parse(chatActionRaw);

  //   if (action !== "convert_rc_to_po") return;

  //   // delay so filter completes
  //   setTimeout(() => {
  //     handleCreatePO();
  //     // navigate("/Buyer_dashboard/po");
  //     sessionStorage.removeItem("CHAT_ACTION");
  //   }, 1000);

  // }, [savedItem]);

  const handleQtyChange = (id, value) => {
    if (!/^\d*$/.test(value)) return;

    setQuantities((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const getEffectiveQuantity = (item) =>
    quantities[item.id] !== undefined
      ? Number(quantities[item.id] || 0)
      : Number(item.quantity || 0);

  const grandTotal = savedItem.reduce((sum, item) => {
    const qty = getEffectiveQuantity(item);
    const rate = Number(item.rate || 0);
    return sum + qty * rate;
  }, 0);

  const handleCreatePO = async () => {
    let rcTokenForPo = selectedContract?.rc_token;
    const buildPoPayload = (token) => ({
      rate_contract_token: token,
      rfq_id: null,
      delivery_date: deliveryDate ? `${deliveryDate}T00:00:00Z` : null,
      payment_date: paymentDate ? `${paymentDate}T00:00:00Z` : null,
      items: savedItem.map((item) => ({
        id: item.id,
        item_name: item.item_name,
        uom: item.uom,
        rate: Number(item.rate),
        quantity: getEffectiveQuantity(item),
        remarks: item.remarks || "",
      })),
      demo: savedItem,
    });

    if (selectedContract?.chatbotConverted) {
      try {
        setCreatingPo(true);
        const headerInfo = {
          purchase_order_no: selectedContract?.purchase_order_number || "",
          purchase_order_date:
            selectedContract?.purchase_order_date || selectedContract?.start_date || "",
          vendor_details:
            selectedContract?.vendor_details || selectedContract?.buyer || "",
        };

        const extractedResponse = {
          header_info: Object.fromEntries(
            Object.entries({
              ...headerInfo,
              generated_for: "po_automation",
            }).filter(
              ([, value]) => value !== "" && value !== null && value !== undefined,
            ),
          ),
          data: savedItem.map((item) => ({
            "Part No": item?.part_no || item?.item_code || "",
            "Description of Goods": item?.item_name || "",
            "HSN Code": item?.hsn_code || "",
            "Qty.": getEffectiveQuantity(item),
            UOM: item?.uom || "",
            Rate: Number(item?.rate || 0),
            Amount:
              Number(item?.total_price || 0) ||
              Number(item?.rate || 0) * getEffectiveQuantity(item),
          })),
          totals: { grand_total: grandTotal },
        };

        const savePayload = {
          buyer_token,
          extracted_response: extractedResponse,
          no_filter: true,
          generated_for: "po_automation",
          reconstructed_pdf_path: "",
        };
        console.log("[RC->PO][Chatbot] save_extracted_rate_contract payload:", savePayload);

        try {
          const saveRes = await axios.post(
            API_ENDPOINT.save_extracted_rate_contract,
            savePayload,
            {
              headers: {
                Authorization: `Token ${auth_token}`,
                "Content-Type": "application/json",
              },
            },
          );

          const savedToken =
            saveRes?.data?.rc_token ||
            saveRes?.data?.rate_contract_token ||
            saveRes?.data?.data?.rc_token ||
            saveRes?.data?.saved_rc?.rc_token ||
            null;
          rcTokenForPo = savedToken || rcTokenForPo;
        } catch (saveErr) {
          const backendMessage =
            saveErr?.response?.data?.error ||
            saveErr?.response?.data?.message ||
            "";
          const gstRequired =
            typeof backendMessage === "string" &&
            backendMessage.toLowerCase().includes("gst");

          if (gstRequired) {
            console.warn(
              "[RC->PO][Chatbot] save_extracted_rate_contract skipped due to GST validation; continuing with filtered items on existing RC token.",
            );
          } else {
            throw saveErr;
          }
        }

        if (!rcTokenForPo) throw new Error("RC token not available for PO conversion");

        const chatbotPoPayload = buildPoPayload(rcTokenForPo);
        console.log("[RC->PO][Chatbot] convert_rate_contract_to_po payload:", chatbotPoPayload);

        await axios.post(API_ENDPOINT.convert_rate_contract_to_po, chatbotPoPayload, {
          headers: {
            Authorization: `Token ${auth_token}`,
            "Content-Type": "application/json",
          },
        });
        setShowSuccessModal(true);
      } catch (err) {
        console.error("[RC->PO][Chatbot] CREATE PO ERROR:", err);
        alert("Failed to create PO");
      } finally {
        setCreatingPo(false);
      }
      return;
    }

    const payload = buildPoPayload(rcTokenForPo);

    if (!navigator.onLine) {
      await db.offlineRcPO.add({
        payload,
        createdAt: Date.now(),
      });

      setOpenOfflinePopup(true);
      return;
    }

    try {
      setCreatingPo(true);

      console.log("FINAL PAYLOAD:", payload);

      await axios.post(API_ENDPOINT.convert_rate_contract_to_po, payload, {
        headers: {
          Authorization: `Token ${auth_token}`,
          "Content-Type": "application/json",
        },
      });

      setShowSuccessModal(true);
    } catch (err) {
      console.error("CREATE PO ERROR:", err);
      alert("Failed to create PO");
    } finally {
      setCreatingPo(false);
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      {/* HEADER */}
      <Box
        sx={{
          mt: 1,
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <HeaderTitle titleText="Rate Contract Items" />
        <Button
          variant="contained"
          size="small"
          sx={{
            fontSize: 15,
            fontWeight: 600,
            textTransform: "none",
            px: 1.5,
            py: 1,
            borderRadius: 1.5,
          }}
          onClick={onBack}
        >
          Back
        </Button>
      </Box>

      {/* FILE UPLOAD BOX (unchanged) */}
      {/* <Box
                onDragOver={ (e) => e.preventDefault() }
                sx={ {
                    mb: "20px",
                    width: "100%",
                    maxWidth: "420px",
                    border: "2px dashed #cbd5e1",
                    borderRadius: "12px",
                    padding: "40px",
                    textAlign: "center",
                    backgroundColor: "#f8fafc",
                    cursor: "pointer",
                    "&:hover": { backgroundColor: "#f1f5f9" },
                } }
            >
                <Typography
                    variant="h6"
                    sx={ {
                        fontWeight: 600,
                        fontSize: 16,
                        color: "#334155",
                        mb: 0.5,
                    } }
                >
                    Drag and drop file here
                </Typography>
                <Typography sx={ { color: "#64748b", fontSize: 14, mb: 2 } }>
                    (Supported format .xlsx, .xls, .csv)
                </Typography>
                <Button
                    variant="outlined"
                    size="medium"
                    sx={ {
                        borderRadius: 2,
                        textTransform: "none",
                        fontSize: 14,
                        fontWeight: 500,
                        px: 2.5,
                    } }
                    onClick={ () => rcInputRef.current.click() }
                >
                    Browse
                </Button>
                <input
                    type="file"
                    ref={ rcInputRef }
                    style={ { display: "none" } }
                    onChange={ (e) => console.log("Selected:", e.target.files[0]) }
                />
            </Box> */}

      {/* UPLOAD BUTTON */}
      {/* <Button
                variant="contained"
                sx={ {
                    fontFamily: "GilroyMedium",
                    textTransform: "none",
                    fontWeight: 600,
                    fontSize: "14px",
                    borderRadius: 1,
                    px: 2.5,
                    py: 1,
                    mb: 3,
                } }
                disabled={ loading }
            >
                { loading ? <CircularProgress size={ 18 } color="inherit" /> : "Upload File" }
            </Button> */}

      {/* ITEMS TABLE */}
      <TableContainer
        component={Paper}
        sx={{
          borderRadius: 2,
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)",
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {["Item Name", "Part No", "Rate", " Exception Remarks", "Quantity", "Unit of Measure", "Total"].map(
                (header, i) => (
                  <TableCell
                    key={i}
                    sx={{
                      fontWeight: 600,
                      fontFamily: "GilroySemiBold",
                      backgroundColor: "#e0e9ee",
                      fontSize: "14px",
                    }}
                  >
                    {header}
                  </TableCell>
                ),
              )}
            </TableRow>
          </TableHead>

          <TableBody>
            {savedItem.map((item) => {
              const qty =
                quantities[item.id] !== undefined
                  ? quantities[item.id]
                  : item.quantity || "";
              const total = (Number(item.rate) || 0) * (Number(qty) || 0);

              return (
                <TableRow key={item.id}>
                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    {item.item_name}
                  </TableCell>

                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    {item.part_number || "-"}
                  
                  </TableCell>

                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    ₹{Number(item.rate).toLocaleString("en-IN")}
                  </TableCell>

                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    {item.remarks || "—"}
                  </TableCell>

                  <TableCell>
                    <TextField
                      value={
                        quantities[item.id] !== undefined
                          ? quantities[item.id]
                          : item.quantity || ""
                      }
                      onChange={(e) => handleQtyChange(item.id, e.target.value)}
                      placeholder="0"
                      type="text"
                      sx={{
                        width: "80px",
                        "& .MuiInputBase-root": {
                          fontSize: "14px",
                          fontFamily: "GilroyMedium",
                        },
                      }}
                    />
                  </TableCell>

                  <TableCell
                    sx={{ fontSize: "14px", fontFamily: "GilroyMedium" }}
                  >
                    {item.uom}
                  </TableCell>

                  <TableCell
                    sx={{
                      fontSize: "14px",
                      fontFamily: "GilroySemiBold",
                      color: "#075b97",
                    }}
                  >
                    ₹{Number(total.toFixed(2)).toLocaleString("en-IN")}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>

      {/* DELIVERY DATE + PAYMENT DATE */}
      <Box sx={{ mt: 3, display: "flex", gap: 3 }}>
        <TextField
          label="Expected Delivery Date"
          type="date"
          value={deliveryDate}
          onChange={(e) => setDeliveryDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{
            width: "250px",
            "& .MuiInputBase-root": {
              fontSize: "14px",
              fontFamily: "GilroyMedium",
            },
          }}
        />

        <TextField
          label="Payment Date"
          type="date"
          value={paymentDate}
          onChange={(e) => setPaymentDate(e.target.value)}
          InputLabelProps={{ shrink: true }}
          sx={{
            width: "250px",
            "& .MuiInputBase-root": {
              fontSize: "14px",
              fontFamily: "GilroyMedium",
            },
          }}
        />
      </Box>

      {/* GRAND TOTAL SECTION */}
      <Box
        sx={{
          mt: 3,
          p: 2,
          borderRadius: 2,
          backgroundColor: "#f0f7fa",
          border: "1px solid #cbd5e1",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            fontSize: "18px",
            fontFamily: "GilroySemiBold",
            color: "#075b97",
          }}
        >
          Grand Total
        </Typography>

        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 700,
            fontFamily: "GilroySemiBold",
            color: "#075b97",
          }}
        >
          ₹{grandTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
        </Typography>
      </Box>

      {/* CREATE PO BUTTON */}
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button
          variant="contained"
          sx={{
            mt: 3,
            fontFamily: "GilroyMedium",
            textTransform: "none",
            fontWeight: 600,
            fontSize: "16px",
            borderRadius: 1,
            px: 2.5,
            py: 1,
          }}
          color="primary"
          onClick={handleCreatePO}
          disabled={creatingPo}
        >
          {creatingPo ? (
            <CircularProgress size={18} color="inherit" />
          ) : (
            "Create Purchase Order"
          )}
        </Button>
      </Box>
      <Modal open={showSuccessModal}>
        <Fade in={showSuccessModal}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText="PO Created Successfully!"
              popupDescription="Your Purchase Order has been generated."
              popBtn={true}
              btnText="OK"
              vendorBtn={true}
              btnClick={() => {
                setShowSuccessModal(false);
                navigate("/Buyer_dashboard/po");
              }}
            />
          </Box>
        </Fade>
      </Modal>

      <Modal open={openOfflinePopup}>
        <Fade in={openOfflinePopup}>
          <Box>
            <SuccessPopupDashboard
              popupImage={successPopupImg}
              popupHeroText="Offline Mode"
              popupDescription="You are working in offline mode. Po will be saved and synchronized with the server when connectivity is restored."
              popBtn={true}
              btnText={"Okay"}
              vendorBtn={true}
              btnClick={() => setOpenOfflinePopup(false)}
            />
          </Box>
        </Fade>
      </Modal>
    </Box>
  );
};

export default RcPoView;
